//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import InputDatepicker from '../../shared-components/datepicker/InputDatepicker';

export default {
  name: 'RateioAcordo',
  data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      dataInicial: '',
      dataFinal: '',
    };
  },
  components: {
    InputDatepicker,
  },
  methods: {
    dataInicialFormatadaStatusNegociacoes(dataInicial) {
      this.dataInicial = dataInicial;
    },
    dataFinalFormatadaStatusNegociacoes(dataFinal) {
      this.dataFinal = dataFinal;
    },
    converterData(data) {
      if (!data) {
        return null;
      }
      const [year, month, day] = data.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    datasValidas() {
      const dataInicial = moment(this.dataInicial);
      const dataFinal = moment(this.dataFinal);

      if ((this.dataInicial && !this.dataFinal) || (this.dataFinal && !this.dataInicial)) {
        this.$toast.create(this.$t('message.data_final_e_inicial'), 'snack', 3E3);
        return false;
      }

      if (dataFinal.isBefore(dataInicial)) {
        this.$toast.create(this.$t('message.data_inicial_maior_final'), 'snack', 3E3);
        return false;
      }

      return true;
    },
    formatarData(data) {
      if (!data) {
        return null;
      }
      const [year, month, day] = data.split('-');
      return `${day}-${month}-${year}`;
    },
    aplicar() {
      if (this.datasValidas()) {
        const filtros = { dataInicio: moment(this.dataInicial, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          dataFim: moment(this.dataFinal, 'DD-MM-YYYY').format('YYYY-MM-DD') };
        this.acordoResources.ratear(filtros).then(() => {
          this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/spa/administracao/RateioAcordo.vue?vue&type=script&lang=js&